<template>
    <v-dialog v-model="dialog">
        <v-card>
            <v-toolbar color="info" dark>
                <v-icon left>mdi-information</v-icon>
                <v-toolbar-title>Información de la Encuesta</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card class="pa-4" v-if="survey" elevation="0">
                <v-card-title>Detalles de la encuesta</v-card-title>
                <v-card-text>
                    <v-row class="align-center">
                        <!-- ID de respuesta -->
                        <v-col cols="12" md="4">
                            <v-text-field
                                prepend-inner-icon="mdi-identifier"
                                v-model="survey.id"
                                label="ID de Encuesta"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <!-- Título de encuesta -->
                        <v-col cols="12" md="4">
                            <v-text-field
                                prepend-inner-icon="mdi-format-title"
                                v-model="survey.survey.name"
                                label="Título de Encuesta"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <!-- Fecha de respuesta -->
                        <v-col cols="12" md="4">
                            <v-text-field
                                prepend-inner-icon="mdi-calendar"
                                :value="dayjs(Number(survey.createdAt)).format('DD/MM/YYYY HH:mm')"
                                label="Fecha de Respuesta"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <!-- ID de orden -->
                        <v-col cols="12" md="4">
                            <v-text-field
                                prepend-inner-icon="mdi-order-bool-ascending"
                                v-model="survey.order"
                                label="ID de Orden"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <!-- El id de orden es valido -->
                        <v-col cols="12" md="4">
                            <v-icon left :color="survey.isValidOrderId ? 'green' : 'red'">
                                {{ survey.isValidOrderId ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                            </v-icon>
                            <span>{{ survey.isValidOrderId ? 'ID de Orden Válido' : 'ID de Orden Inválido' }}</span>
                        </v-col>
                        <!-- ID de orden duplicado -->
                        <v-col cols="12" md="4">
                            <v-icon left :color="survey.hasOrderIdBeenUsed ? 'red' : 'green'">
                                {{ survey.hasOrderIdBeenUsed ? 'mdi-alert-circle' : 'mdi-check-circle' }}
                            </v-icon>
                            <span>{{ survey.hasOrderIdBeenUsed ? 'ID de Orden Duplicado' : 'ID de Orden Único' }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-title>Respuestas de la encuesta</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" v-for="question of survey.survey.questions" :key="question.id">
                            <v-text-field
                                :label="question.question"
                                readonly
                                :value="survey.questions.find(q => q.question === question.id).value || 'No respondido'"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" @click="dialog = false">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import dayjs from 'dayjs';

    export default {
        name: "SurveyResponseInfo",
        props: {
            survey: {
                type: Object
            },
            value: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dayjs
            };
        },
        computed: {
            dialog: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>